import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i)">
        <path
          d="M12.0001 10.8C13.3256 10.8 14.4001 9.50595 14.4001 7.9097C14.4001 6.31344 13.3256 7.90841 12.0001 7.90841C10.6746 7.90841 9.6001 6.31344 9.6001 7.9097C9.6001 9.50595 10.6746 10.8 12.0001 10.8Z"
          fill="#A3A3A3"
        />
      </g>
      <path
        d="M13.2328 8.37216C13.3804 8.30815 13.5181 8.23994 13.6377 8.17902C13.5297 9.3392 12.7319 10.05 12.0001 10.05C11.2683 10.05 10.4705 9.33922 10.3624 8.17902C10.4821 8.23994 10.6198 8.30815 10.7674 8.37216C11.0975 8.51541 11.522 8.65841 12.0001 8.65841C12.4782 8.65841 12.9027 8.51541 13.2328 8.37216Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
      />
      <path
        d="M2.3999 7.80005L21.5999 7.80005"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7998 12.2932L19.9998 15.2978"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2002 12.2932L4.0002 15.2978"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.7954V16.8"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
